import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCityState } from "./contactAPI";

const initialState = null;

export const fetchCityState = createAsyncThunk(
    'ui/fetchCityState',
    async (zipcode, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await getCityState(zipcode);
      return response.data;
    }
);

const contactSlice = createSlice({
    name: 'address',
    initialState,
    reducers: {
      resetCityStateReducer: () => initialState,
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchCityState.pending, (state) => {
            return {
              ...state,
              status: "loading",
              dataLoaded: false,
              dataFetchFailed: false,
              cityState: initialState
            }
          })
          .addCase(fetchCityState.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              cityState: action.payload,
              dataFetchFailed: false,
              dataLoaded: true
            }
          })
          .addCase(fetchCityState.rejected, (state) => {
            return {
              ...state,
              dataFetchFailed: true,
              status: "idle",
              dataLoaded: true,
            }
          })
        },
});

export const getCityStateByZip = (state) => state.address?.cityState;
export const { resetCityStateReducer } = contactSlice.actions;
export default contactSlice.reducer;
